module.exports = __webpack_public_path__ + "static/media/alles_falsch_ausser_arbeitsmittel.f4015bdb.jpg";